import styled from 'styled-components';

export const FullWidthContainer = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  border-bottom-left-radius: 80px;
  overflow: hidden;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;

  & img {
    object-fit: cover;
    height: 250px;
    width: 100%;
    max-width: 410px;
  }
`;

export const OnBoardingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & h1 {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #1d201f;
    margin-bottom: 2px;
  }

  & h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #1d201f;
    margin-bottom: 10px;
  }

  & h3 {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #1d201f;
    margin-bottom: 10px;
  }

  & p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 40px;

    & span.ql-size-large {
      font-size: 18px;
    }

    & span.ql-size-small {
      font-size: 10px;
      line-height: 14px;
    }
  }

  & .ql-align-center {
    text-align: center;
  }

  & .start-btn {
    background: #f24e1e;
    font-size: 18px;
    color: #f5f9ff;

    &:active {
      background: #c13e18;
    }
  }

  & .next-buttons-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    column-gap: 10px;

    & button {
      padding: 12px 2px;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #f5f9ff;
    }
  }

  & p.full-width {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-bottom: 30px;

    & img {
      object-fit: cover;
      height: auto;
      width: 100%;
    }
  }
`;
